<template>
    <div :class="containerClass">
        <div class="layout-config-content-wrapper">
            <a href="#" class="layout-config-button" @click="toggleConfigurator">
                <i class="pi pi-cog"></i>
            </a>
            <a href="#" class="layout-config-close" @click="hideConfigurator">
                <i class="pi pi-times"></i>
            </a>

            <div class="layout-config-content">
                <div>
                    <h5>Bootstrap</h5>
                    <div class="grid free-themes">
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('bootstrap4-light-blue')">
                                <img src="../../assets/img/themes/bootstrap4-light-blue.svg" alt="Bootstrap Light Blue" />
                            </button>
                            <span>Blue</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('bootstrap4-light-purple')">
                                <img src="../../assets/img/themes/bootstrap4-light-purple.svg" alt="Bootstrap Light Blue" />
                            </button>
                            <span>Purple</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('bootstrap4-dark-blue', true)">
                                <img src="../../assets/img/themes/bootstrap4-dark-blue.svg" alt="Bootstrap Dark Blue" />
                            </button>
                            <span>Blue</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('bootstrap4-dark-purple', true)">
                                <img src="../../assets/img/themes/bootstrap4-dark-purple.svg" alt="Bootstrap Dark Blue" />
                            </button>
                            <span>Purple</span>
                        </div>
                    </div>

                    <h5>Material Design</h5>
                    <div class="grid free-themes">
                         <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('md-light-indigo')">
                                <img src="../../assets/img/themes/md-light-indigo.svg" alt="Material Light Indigo" />
                            </button>
                            <span>Indigo</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('md-light-deeppurple')">
                                <img src="../../assets/img/themes/md-light-deeppurple.svg" alt="Material Light Deep Purple" />
                            </button>
                            <span>Deep Purple</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('md-dark-indigo', true)">
                                <img src="../../assets/img/themes/md-dark-indigo.svg" alt="Material Dark Indigo" />
                            </button>
                            <span>Indigo</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('md-dark-deeppurple', true)">
                                <img src="../../assets/img/themes/md-dark-deeppurple.svg" alt="Material Dark Deep Purple" />
                            </button>
                            <span>Deep Purple</span>
                        </div>
                    </div>

                    <h5>Material Design Compact</h5>
                    <div class="grid free-themes">
                         <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('mdc-light-indigo')">
                                <img src="../../assets/img/themes/md-light-indigo.svg" alt="Material Compact Light Indigo"/>
                            </button>
                            <span>Indigo</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('mdc-light-deeppurple')">
                                <img src="../../assets/img/themes/md-light-deeppurple.svg" alt="Material Compact Deep Purple" />
                            </button>
                            <span>Deep Purple</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('mdc-dark-indigo', true)">
                                <img src="../../assets/img/themes/md-dark-indigo.svg" alt="Material Compact Dark Indigo" />
                            </button>
                            <span>Indigo</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('mdc-dark-deeppurple', true)">
                                <img src="../../assets/img/themes/md-dark-deeppurple.svg" alt="Material Compact Dark Deep Purple" />
                            </button>
                            <span>Deep Purple</span>
                        </div>
                    </div>

                    <h5>TAILWIND & Fluent UI</h5>
                    <div class="grid free-themes">
                         <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('tailwind-light')">
                                <img src="../../assets/img/themes/tailwind-light.png" alt="Tailwind Light"/>
                            </button>
                            <span>Tailwind Light</span>
                        </div>
                         <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('fluent-light')">
                                <img src="../../assets/img/themes/fluent-light.png" alt="Fluent Light"/>
                            </button>
                            <span>Fluent Light</span>
                        </div>
                    </div>

                    <h5>PrimeOne Design - 2022</h5>
                    <div class="grid free-themes">
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('lara-light-indigo')">
                                <img src="../../assets/img/themes/lara-light-indigo.png" alt="Lara Light Indigo" />
                            </button>
                            <span>Lara Light Indigo</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('lara-light-blue')">
                                <img src="../../assets/img/themes/lara-light-blue.png" alt="Lara Light Blue" />
                            </button>
                            <span>Lara Light Blue</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('lara-light-purple')">
                                <img src="../../assets/img/themes/lara-light-purple.png" alt="Lara Light Purple" />
                            </button>
                            <span>Lara Light Purple</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('lara-light-teal')">
                                <img src="../../assets/img/themes/lara-light-teal.png" alt="Lara Light Teal" />
                            </button>
                            <span>Lara Light Teal</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('lara-dark-indigo', true)">
                                <img src="../../assets/img/themes/lara-dark-indigo.png" alt="Lara Dark Indigo" />
                            </button>
                            <span>Lara Dark Indigo</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('lara-dark-blue', true)">
                                <img src="../../assets/img/themes/lara-dark-blue.png" alt="Lara Dark Blue" />
                            </button>
                            <span>Lara Dark Blue</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('lara-dark-purple', true)">
                                <img src="../../assets/img/themes/lara-dark-purple.png" alt="Lara Dark Purple" />
                            </button>
                            <span>Lara Dark Purple</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('lara-dark-teal', true)">
                                <img src="../../assets/img/themes/lara-dark-teal.png" alt="Lara Dark Teal" />
                            </button>
                            <span>Lara Dark Teal</span>
                        </div>
                    </div>

                    <h5>PrimeOne Design</h5>
                    <div class="grid free-themes">
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('saga-blue')">
                                <img src="../../assets/img/themes/saga-blue.png" alt="Saga Blue" />
                            </button>
                            <span>Saga Blue</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('saga-green')">
                                <img src="../../assets/img/themes/saga-green.png" alt="Saga Green" />
                            </button>
                            <span>Saga Green</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('saga-orange')">
                                <img src="../../assets/img/themes/saga-orange.png" alt="Saga Orange" />
                            </button>
                            <span>Saga Orange</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('saga-purple')">
                                <img src="../../assets/img/themes/saga-purple.png" alt="Saga Purple" />
                            </button>
                            <span>Saga Purple</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('vela-blue', true)">
                                <img src="../../assets/img/themes/vela-blue.png" alt="Vela Blue" />
                            </button>
                            <span>Vela Blue</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('vela-green', true)">
                                <img src="../../assets/img/themes/vela-green.png" alt="Vela Green" />
                            </button>
                            <span>Vela Green</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('vela-orange', true)">
                                <img src="../../assets/img/themes/vela-orange.png" alt="Vela Orange" />
                            </button>
                            <span>Vela Orange</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('vela-purple', true)">
                                <img src="../../assets/img/themes/vela-purple.png" alt="Vela Purple" />
                            </button>
                            <span>Vela Purple</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('arya-blue', true)">
                                <img src="../../assets/img/themes/arya-blue.png" alt="Arya Blue" />
                            </button>
                            <span>Arya Blue</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('arya-green', true)">
                                <img src="../../assets/img/themes/arya-green.png" alt="Arya Green" />
                            </button>
                            <span>Arya Green</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('arya-orange', true)">
                                <img src="../../assets/img/themes/arya-orange.png" alt="Arya Orange" />
                            </button>
                            <span>Arya Orange</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('arya-purple', true)">
                                <img src="../../assets/img/themes/arya-purple.png" alt="Arya Purple" />
                            </button>
                            <span>Arya Purple</span>
                        </div>
                    </div>

                    <h4>Legacy Free Themes</h4>
                    <div class="grid free-themes">
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('nova')">
                                <img src="../../assets/img/themes/nova.png" alt="Nova" />
                            </button>
                            <span>Nova</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('nova-alt')">
                                <img src="../../assets/img/themes/nova-alt.png" alt="Nova Alt" />
                            </button>
                            <span>Nova Alt</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('nova-accent')">
                                <img src="../../assets/img/themes/nova-accent.png" alt="Nova Accent" />
                            </button>
                            <span>Nova Accent</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('nova-vue')">
                                <img src="../../assets/img/themes/nova-vue.png" alt="Nova Colored" />
                            </button>
                            <span>Nova Vue</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('luna-blue', true)">
                                <img src="../../assets/img/themes/luna-blue.png" alt="Luna Blue" />
                            </button>
                            <span>Luna Blue</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('luna-green', true)">
                                <img src="../../assets/img/themes/luna-green.png" alt="Luna Green" />
                            </button>
                            <span>Luna Green</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('luna-amber', true)">
                                <img src="../../assets/img/themes/luna-amber.png" alt="Luna Amber" />
                            </button>
                            <span>Luna Amber</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('luna-pink', true)">
                                <img src="../../assets/img/themes/luna-pink.png" alt="Luna Pink" />
                            </button>
                            <span>Luna Pink</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('rhea', false)">
                                <img src="../../assets/img/themes/rhea.png" alt="Rhea" />
                            </button>
                            <span>Rhea</span>
                        </div>
                    </div>
                    
                    <!-- <h4>Premium Themes</h4>
                    <div class="grid free-themes">
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('soho-light')">
                                <img src="../../assets/img/themes/soho-light.png" alt="Soho Light" />
                            </button>
                            <span>Soho Light</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('soho-dark', true)">
                                <img src="../../assets/img/themes/soho-dark.png" alt="Soho Dark" />
                            </button>
                            <span>Soho Dark</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('viva-light')">
                                <img src="../../assets/img/themes/viva-light.svg" alt="Viva Light" />
                            </button>
                            <span>Viva Light</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('viva-dark', true)">
                                <img src="../../assets/img/themes/viva-dark.svg" alt="Viva Dark" />
                            </button>
                            <span>Viva Dark</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('mira')">
                                <img src="../../assets/img/themes/mira.jpg" alt="Mira" />
                            </button>
                            <span>Mira</span>
                        </div>
                        <div class="col-3">
                            <button class="p-link" type="button" @click="changeTheme('nano')">
                                <img src="../../assets/img/themes/nano.jpg" alt="Mira" />
                            </button>
                            <span>Nano</span>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'

export default {
    name: "tw-theme",
    data() {
        return {
            active: false
        }
    },
    watch: {
        $route() {
            if (this.active) {
                this.active = false;
                this.unbindOutsideClickListener();
            }
        }
    },
    setup(){
        const store = useStore()
        const theme = localStorage.getItem('tw_design_theme');
        var themeElement = document.getElementById('theme-link');

        if(themeElement && theme){
            themeElement.setAttribute('href', themeElement.getAttribute('href').replace('saga-blue', theme));
        }

        const changeTheme = (theme, dark = false) => {
            const oldTheme = localStorage.getItem('tw_design_theme') ?? 'saga-blue';
            var themeElement = document.getElementById('theme-link');

            if(themeElement){
                themeElement.setAttribute('href', themeElement.getAttribute('href').replace(oldTheme, theme));
                localStorage.setItem('tw_design_theme', theme);
                store.commit('setDark', dark)
            }
            
        }

        return {
            changeTheme
        }
    },
    methods: {
        toggleConfigurator(event) {
            this.active = !this.active;
            event.preventDefault();

            if (this.active)
                this.bindOutsideClickListener();
            else
                this.unbindOutsideClickListener();
        },
        hideConfigurator(event) {
            this.active = false;
            this.unbindOutsideClickListener();
            event.preventDefault();
        },
        bindOutsideClickListener() {
            if (!this.outsideClickListener) {
                this.outsideClickListener = (event) => {
                    if (this.active && this.isOutsideClicked(event)) {
                        this.active = false;
                    }
                };
                document.addEventListener('click', this.outsideClickListener);
            }
        },
        unbindOutsideClickListener() {
            if (this.outsideClickListener) {
                document.removeEventListener('click', this.outsideClickListener);
                this.outsideClickListener = null;
            }
        },
        isOutsideClicked(event) {
            return !(this.$el.isSameNode(event.target) || this.$el.contains(event.target));
        }
    },
    computed: {
        containerClass() {
            return ['layout-config', {'layout-config-active': this.active}];
        }
    }
}
</script>
<style>
.layout-config {
  position: fixed;
  padding: 0;
  top: 0;
  right: 0;
  display: block;
  width: 550px;
  z-index: 998;
  height: 100%;
  transition: transform 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);
  transform: translateX(100%);
  backface-visibility: hidden;
}
.layout-config.layout-config-active {
  transform: translateX(0);
}
.layout-config.layout-config-active .layout-config-content-wrapper .layout-config-button i {
  transform: rotate(0deg);
}
.layout-config .layout-config-content-wrapper {
  position: relative;
  height: 100%;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.24);
  color: var(--text-color);
  background-color: var(--surface-f);
}
.layout-config .layout-config-content-wrapper .layout-config-button {
  display: block;
  position: absolute;
  width: 52px;
  height: 52px;
  line-height: 52px;
  background-color: var(--primary-color);
  text-align: center;
  color: var(--primary-color-text);
  top: 270px;
  left: -51px;
  z-index: -1;
  overflow: hidden;
  cursor: pointer;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  animation-name: rubberBand;
  animation-duration: 1s;
  animation-iteration-count: 3;
  animation-delay: 5s;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.layout-config .layout-config-content-wrapper .layout-config-button i {
  font-size: 26px;
  line-height: inherit;
  cursor: pointer;
  transform: rotate(360deg);
  transition: transform 1s;
}
.layout-config a {
  color: #2196f3;
  font-weight: 600;
}
.layout-config a:hover {
  text-decoration: underline;
}
.layout-config .layout-config-content {
  overflow: auto;
  height: 100%;
  padding: 2rem;
}
.layout-config .config-scale {
  display: flex;
  align-items: center;
  margin: 1rem 0 2rem 0;
}
.layout-config .config-scale .p-button {
  margin-right: 0.5rem;
}
.layout-config .config-scale i {
  margin-right: 0.5rem;
  font-size: 0.75rem;
  color: var(--text-color-secondary);
}
.layout-config .config-scale i.scale-active {
  font-size: 1.25rem;
  color: #2196f3;
}
.layout-config .layout-config-close {
  position: absolute;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  right: 20px;
  top: 20px;
  z-index: 999;
  background-color: var(--primary-color);
  border-radius: 50%;
  transition: background-color 0.2s, box-shadow 0.2s, transform 0.2s;
}
.layout-config .layout-config-close i {
  color: var(--primary-color-text);
  line-height: inherit;
  font-size: 14px;
}
.layout-config .layout-config-close:hover {
  transform: scale(1.1);
}
.layout-config .layout-config-close:focus {
  outline: 0 none;
  box-shadow: 0 0 0 0.2rem #BBDEFB;
}
.layout-config .grid > div {
  padding: 1rem;
  text-align: center;
}
.layout-config .grid > div span {
  display: block;
}
.layout-config .grid > div button {
  position: relative;
  display: inline-flex;
  justify-content: center;
}
.layout-config .free-themes img {
  width: 50px;
  border-radius: 4px;
  transition: transform 0.2s;
}
.layout-config .free-themes img:hover {
  transform: scale(1.1);
}
.layout-config .free-themes span {
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
.layout-config .premium-themes img {
  width: 100%;
  transition: transform 0.2s;
}
.layout-config .premium-themes img:hover {
  transform: scale(1.1);
}

@keyframes rubberBand {
  from {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    transform: scale3d(1.05, 0.95, 1);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
</style>